import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteFooterComponent } from '../site-footer/site-footer.component';

@Component({
  selector: 'app-terminos-propietarios',
  imports: [RouterLink, SiteFooterComponent],
  templateUrl: './terminos-propietarios.component.html',
})
export class TerminosPropietariosComponent {
  readonly updated = '13 de mayo de 2026';
}
